export const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: "$",
  EUR: "€",
};

// Resolve a display symbol from an ISO currency code (e.g. the `currency`
// field of /client_api/user). A known code maps to its sign. An unknown but
// present code returns the code itself — degraded but never the wrong sign
// next to a real amount. Missing/blank codes take the caller's fallback
// (partner config) so pre-login screens stay branded.
export const getCurrencySymbol = (code: unknown, fallback: string): string => {
  if (typeof code !== "string" || code.trim() === "") return fallback;
  const normalized = code.trim().toUpperCase();
  return CURRENCY_SYMBOLS[normalized] ?? normalized;
};

export const getCurrencyCode = (code: unknown, fallback: string): string =>
  typeof code === "string" && code.trim() !== ""
    ? code.trim().toUpperCase()
    : fallback;
